import React, { Fragment } from 'react';
import { css } from 'twin.macro';
import { customCheckbox } from '@/_elements/CustomCheckbox';
import { Form } from 'react-bootstrap';

const SignatureProperties = ({ element, register }) => {
    return (
        <Fragment>
            {/* Show Field Title in Pdf Template */}
            <Form.Group
                controlId="showTitleInPdfTemplateView"
                css={css`
                    display: flex;
                    align-items: center;
                    .requiredCheckbox {
                        width: 20px;
                        height: 20px;
                    }
                `}
            >
                <Form.Control
                    className="requiredCheckbox"
                    type="checkbox"
                    css={customCheckbox}
                    name="options.showTitleInPdfTemplateView"
                    defaultChecked={(element?.options || {}).showTitleInPdfTemplateView || false}
                    ref={register({
                        setValueAs: (value) => !!value,
                    })}
                />
                <Form.Label
                    css={css`
                        margin: 0;
                    `}
                >
                    Show field title in PDF template
                </Form.Label>
            </Form.Group>
        </Fragment>
    );
};

export default SignatureProperties;
